'use client'

import { FlowStepper } from '@/shared/components/FlowStepper'

const AUTH_STEPS = [{ label: 'Aktivasi' }, { label: 'Login PIN' }] as const

type DelmanAuthFlowStepperProps = {
  /** 1 = aktivasi, 2 = login PIN */
  activeStep: 1 | 2
}

export function DelmanAuthFlowStepper({ activeStep }: DelmanAuthFlowStepperProps) {
  return (
    <div className="w-full px-1">
      <FlowStepper steps={[...AUTH_STEPS]} activeStep={activeStep} />
    </div>
  )
}
